import API from "./apiInstance";

export const getAllTemplates = (id) => {
  return API.get(`/review_template`);
};
